// 添加公司人员
import { ref } from 'vue'
import { Toast, Notify } from 'vant'
export const useAddPersonnel = (method, callback) => {
  const addPersonnel = ref(null)
  const handleAddPersonnelClick = () => {
    addPersonnel.value.showPopup()
  }
  const handleAddPersonnelSubmit = async (params) => {
    addPersonnel.value.loading = true
    // Toast.allowMultiple()
    const toast1 = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      overlay: true,
      message: '请稍后...'
    })
    try {
      const { status, message } = await method(params)
      if (status === 200) {
        Notify({ type: 'success', message: '添加成功' })
        callback()
        addPersonnel.value.hidePopup()
      } else {
        Notify({ type: 'warning', message: message })
      }
      addPersonnel.value.loading = false
      toast1.clear()
    } catch {
      addPersonnel.value.loading = false
      toast1.clear()
    }
  }
  return {
    addPersonnel,
    handleAddPersonnelClick,
    handleAddPersonnelSubmit
  }
}
